import { translate } from 'react-i18next';
import styled from 'styled-components';
import StylizedCashIcon from 'assets/images/payments/stylized-cash-icon.svg';

const Wrapper = styled.div`
  border: 1px solid ${props => props.theme.color.border};
  margin-top: 1em;
  padding: 1em;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 5em;
  position: absolute;
  width: calc(100% - 2em);
  height: calc(100% - 12.1875em);
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
`;

const Image = styled.img`
  width: 96px;
  height: 96px;
  margin-bottom: 2em;
`;

const Text = styled.span`
  font-size: 18px;
  text-align: center;
  color: ${props => props.theme.color.label};
`;

export default translate()(props => (
  <Wrapper>
    <ContentWrapper>
      <Image src={StylizedCashIcon} />
      <Text>{props.i18n.t('no_data')}</Text>
    </ContentWrapper>
  </Wrapper>
));
